import { Box, Group, Stack, Text, Title } from '@mantine/core';

import { Content, EXTRA_WIDE_CONTENT_WIDTH } from 'components/page/Content';
import { useCurrentTeam } from 'hooks/use-current-team';
import { useCurrentUser } from 'hooks/use-current-user';

import { DashboardPlanReplus } from './DashboardPlanReplus';
import { DashboardUnread } from './DashboardUnread';

import cx from './Dashboard.module.scss';

const DashboardHeroReplus = () => {
    const user = useCurrentUser();
    const team = useCurrentTeam();

    const firstName = user?.name?.split(' ')[0];

    return (
        <Box className={cx.hero} data-replus>
            <Content width={EXTRA_WIDE_CONTENT_WIDTH}>
                <Group justify="space-between" align="center" gap="lg" py="lg">
                    <Stack gap={4}>
                        <Title order={1} c="white" fz={{ base: 26, md: 34 }} fw={800} lh={1.1}>
                            Welcome back{firstName && `, ${firstName}`}
                        </Title>
                        {team && (
                            <Text fz="md" c="gray.3">
                                Team: {team.name}
                            </Text>
                        )}
                        <DashboardUnread fz="md" />
                    </Stack>
                    {team && <DashboardPlanReplus team={team} />}
                </Group>
            </Content>
        </Box>
    );
};

export { DashboardHeroReplus };
